import { render } from "./login.vue?vue&type=template&id=728e2120&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=728e2120&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\h5 - 副本\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728e2120"]])

export default __exports__